import React from "react";
import NavigationDrawer from "../../../components/NavigationDrawer/index";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import { Grid } from "@mui/material";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import Invoices from "./Invoices";
import AllPlans from "./AllPlans";
import { t } from "i18next";

const tabs = [
  { label: "invoices", value: "invoice" },
  { label: "allSubscriptions", value: "subscription" },
];

function CompanySubscription() {
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.activeTab.tabs);

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, compnay_subscription: tab }));
  };

  return (
    <NavigationDrawer>
      <Grid container spacing={1}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading={t("plans")}
            tabs={tabs}
            activeTab={activeTab.compnay_subscription}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          {activeTab.compnay_subscription === "invoice" ? (
            <Invoices />
          ) : (
            <AllPlans />
          )}
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
}

export default CompanySubscription;
